module.exports = __webpack_public_path__ + "img/edit-primary-alt.ff8657e1.svg";